import React from 'react';
import { Grid } from '@mui/material';
import { Form } from 'react-final-form';

import { Card, CardContent, Typography, Button, ConfirmDialog } from '@occc-app/design-system';
import { OfferSelect } from '@occc-app/routes/CampaignComponents/components/OfferSelect';
import { useExecuteLoyaltyEvents } from '@occc-app/routes/Member/MemberDetailsPage/components/ExecuteLoyaltyEvents/useExecuteLoyaltyEvents';

const ExecuteLoyaltyEvents = ({
  memberName,
  customerUuid,
  onExecuted,
}: {
  memberName: string;
  customerUuid: string;
  onExecuted?: () => void;
}) => {
  const {
    isConfirmDialogOpen,
    closeConfirmDialog,
    makeLoyaltyEventFilter,
    loyaltyEventName,
    submit,
    execute,
    loading,
    isUserPermittedToExecuteLoyaltyEvent,
  } = useExecuteLoyaltyEvents(customerUuid, onExecuted);

  return (
    <>
      <Card sx={{ mb: 0 }}>
        <CardContent>
          <Typography variant='h6' component='h3' paragraph>
            Loyalty Events
          </Typography>
          <Form
            onSubmit={submit}
            render={({ handleSubmit, values }) => {
              const isExecuteEventButtonDisabled =
                !values.loyaltyEvent || !isUserPermittedToExecuteLoyaltyEvent;

              return (
                <Grid
                  container
                  spacing={2}
                  alignItems='center'
                  component='form'
                  onSubmit={handleSubmit}
                >
                  <Grid item xs={12} md={6}>
                    <OfferSelect
                      makeOffersFilter={makeLoyaltyEventFilter}
                      name='loyaltyEvent'
                      label='Pick a Event'
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Button
                      type='submit'
                      variant='contained'
                      color='primary'
                      disabled={isExecuteEventButtonDisabled}
                    >
                      Execute Event
                    </Button>
                  </Grid>
                </Grid>
              );
            }}
          ></Form>
        </CardContent>
      </Card>
      <ConfirmDialog
        showLoadingOverlay={loading}
        dialogTitle={
          <>
            Are you sure you would like to execute <b>{loyaltyEventName || 'Loyalty Event'}</b> for{' '}
            <b>{memberName}</b>?
          </>
        }
        open={isConfirmDialogOpen}
        onClose={closeConfirmDialog}
        confirmButtonText='Execute Loyalty Event'
        confirmButtonProps={{
          disabled: loading,
          onClick: execute,
        }}
      >
        <Typography>
          This will fulfill the offer and award the member, as long as offer limits have not been
          met. This cannot be undone.
        </Typography>
      </ConfirmDialog>
    </>
  );
};

export default ExecuteLoyaltyEvents;
